export default __webpack_public_path__ + "static/media/GuyAnimation6.535c3561.svg";